import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CdkAccordionModule } from '@angular/cdk/accordion';
import { DecimalPipe } from '@angular/common';
import { ItemStockAmount, StockLocationInfo } from '../../../types/item-stock-amount';

import { FormatPipe } from '@softline/ui-core';
import { IconComponent } from '@softline/ui-core';
import { InterpolatePipe } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-lagerstaende',
  imports: [CdkAccordionModule, DecimalPipe,
    FormatPipe,
    IconComponent,
    InterpolatePipe,
    TranslatePipe],
  templateUrl: './lagerstaende.html',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class Lagerstaende {
  data = input.required<ItemStockAmount | null>();
  expanded = input.required<boolean>();
  showNextOrderDate = input.required<boolean>();
  showBewegungen = output<{ stockLocation: StockLocationInfo }>();
}
